<div class="accordion" id="accordionSummaryLocation">
  <button
    *ngIf="!readOnly"
    class="sidebar__trigger"
    data-bs-toggle="collapse"
    data-bs-target="#collapseSummaryLocation"
    aria-expanded="true"
    aria-controls="collapseSummaryLocation"
    [class.collapsed]="vouchers"
  >
    <h5 *ngIf="!isPremium" class="h5 sidebar__section-title">
      {{ 'sharedModule.bkgSummaryLocation.location' | translate }}
    </h5>
    <h5 *ngIf="isPremium" class="h5 sidebar__section-title">
      {{ 'sharedModule.bkgSummaryLocation.premiumLocation' | translate }}
    </h5>
  </button>
  <h5 *ngIf="readOnly && !isPremium" class="h5 sidebar__section-title">
    {{ 'sharedModule.bkgSummaryLocation.location' | translate }}
  </h5>
  <h5 *ngIf="readOnly && isPremium" class="h5 sidebar__section-title">
    {{ 'sharedModule.bkgSummaryLocation.premiumLocation' | translate }}
  </h5>
  <div
    id="collapseSummaryLocation"
    class="accordion-collapse collapse"
    [class.show]="!vouchers || vouchers.length == 0"
    data-bs-parent="#accordionSummaryLocation"
  >
    <div class="accordion-body">
      <div class="sidebar__content">
        <div *ngIf="!readOnly" class="sidebar__content-item">
          {{
            'sharedModule.bkgSummaryLocation.locationDescription' | translate
          }}
        </div>
        <div class="sidebar__content-item">
          <button (click)="openMapDialog()" class="sidebar__map">
            <img
              [src]="imgShow"
              sizes="100%"
              [alt]="
                'sharedModule.bkgSummaryLocation.parkingLocation' | translate
              "
            />
            <div class="sidebar__map-icon">
              <img
                src="assets/images/icons/expand.svg"
                [alt]="'sharedModule.bkgSummaryLocation.openMap' | translate"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
